import { defineComponent, ref, createElementBlock, openBlock, normalizeClass, createCommentVNode, createVNode, Fragment, renderList, createBlock, resolveDynamicComponent, withCtx, unref, mergeProps } from 'vue';
import _sfc_main$2 from './basler-components.es110.js';
/* empty css                        */
import _sfc_main$1 from './basler-components.es87.js';
/* empty css                       */
import _sfc_main$3 from './basler-components.es193.js';
/* empty css                        */
import RenderlessComponent from './basler-components.es249.js';
import { MyClientOnly } from './basler-components.es399.js';

const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
  key: 1,
  class: "product-detail-gallery__items"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductDetailGallery",
  props: {
    items: {},
    lightboxGallery: {},
    isLoading: { type: Boolean, default: false }
  },
  setup(__props) {
    const lightboxGalleryRef = ref(null);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["product-detail-gallery", { "product-detail-gallery--is-loading": _ctx.isLoading }])
      }, [
        _ctx.isLoading ? (openBlock(), createElementBlock("div", _hoisted_1, [
          createVNode(_sfc_main$1, { class: "product-detail-gallery__loading-image" })
        ])) : !_ctx.isLoading && _ctx.items.length > 0 ? (openBlock(), createElementBlock("ul", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
            return openBlock(), createElementBlock("li", {
              class: "product-detail-gallery__item",
              key: index
            }, [
              (openBlock(), createBlock(resolveDynamicComponent(_ctx.lightboxGallery ? "button" : RenderlessComponent), {
                type: _ctx.lightboxGallery ? "button" : void 0,
                class: "product-detail-gallery__item-btn",
                "aria-label": _ctx.lightboxGallery ? _ctx.lightboxGallery?.triggerBtnLabel : void 0,
                onClick: ($event) => _ctx.lightboxGallery && lightboxGalleryRef.value ? lightboxGalleryRef.value.openLightbox(index, $event) : void 0
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$2, {
                    lazyload: false,
                    media: item.media,
                    cols: [4, 3, 2]
                  }, null, 8, ["media"])
                ]),
                _: 2
              }, 1032, ["type", "aria-label", "onClick"]))
            ]);
          }), 128))
        ])) : createCommentVNode("", true),
        createVNode(unref(MyClientOnly), null, {
          default: withCtx(() => [
            _ctx.lightboxGallery ? (openBlock(), createBlock(_sfc_main$3, mergeProps({
              key: 0,
              ref_key: "lightboxGalleryRef",
              ref: lightboxGalleryRef
            }, _ctx.lightboxGallery), null, 16)) : createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2);
    };
  }
});

export { _sfc_main as default };
